export default __webpack_public_path__ + "static/media/AG01.c06810e3.mp3";